import CopyToClipboard from 'src/legacy/components/CopyToClipboard/CopyToClipboard';

export default CopyToClipboard;

export * from './CopyText';
